import React, {useEffect, useState} from 'react';
import styles from './index.module.less';
import {Button, Callout, Card, Checkbox, Classes, Collapse, Intent, Toaster} from "@blueprintjs/core";
import CheckboxGroup from "../CheckboxGroup";
import {Position} from "monaco-editor";

const AnswerToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
  usePortal: true
});
const MultipleChooseQuestion = ({ exercise, onSubmit}) => {
  const [values, setValues] = useState([]);
  const [answered, setAnswered] = useState(false);
  const [answerRight, setAnswerRight] = useState(false);
  const [tipsOpen, setTipsOpen] = useState(false);
  useEffect(() => {
    if (exercise.answer.length === 0) {
      return;
    }
    if (answered) {
      let right = true;
      exercise.answer.sort().forEach((option, index) => {
        if (option !== values[index]) {
          right = false;
        }
      });
      setAnswerRight(right);
    }
  }, [answered, values, exercise]);

  useEffect(() => {
    if (exercise.selectedAnswer.length > 0) {
      setValues(exercise.selectedAnswer);
      setAnswered(true);
    }
  }, [exercise]);

  const handleSubmitAnswer = () => {
    if (values.length > 0) {
      setAnswered(true);
      onSubmit(values, exercise.id);
    } else {
      AnswerToaster.show({
        message: '请选择选项后再提交',
        intent: Intent.WARNING,
        icon: 'issue',
        timeout: 1000
      });
    }
  };
  return (
    <div className={styles['multiple-choose-question']}>
      <Card>
        <h5 className={Classes.HEADING}>多项选择题：{exercise.title}</h5>
        <CheckboxGroup values={values} onChange={setValues} disabled={answered}>
          {exercise.options.map((option) => <Checkbox key={option.key} large value={option.key}>{option.key}. {option.content}</Checkbox>)}
        </CheckboxGroup>
        <div className={styles['card-footer']}>
          <Button small onClick={handleSubmitAnswer} disabled={answered}>提交选项</Button>
        </div>
      </Card>
      <Callout intent={answered ? (answerRight ? Intent.SUCCESS : Intent.DANGER ) : ''} className={styles['tips-container']}>
        <div className={styles['tips-title']}>
          <h5 className={Classes.HEADING}>{answered ? (answerRight ? '答案正确' : `答案错误，正确选项：${exercise.answer.join(', ')}`) : '答案解析'}</h5>
          <Button icon={tipsOpen ? 'chevron-up' : 'chevron-down'} small onClick={() => setTipsOpen(!tipsOpen)} />
        </div>
        <Collapse isOpen={tipsOpen}>
          {exercise.tips}
        </Collapse>
      </Callout>
    </div>
  );
};

export default MultipleChooseQuestion;
